import { render, staticRenderFns } from "./claimReportApply.vue?vue&type=template&id=2ef4a4df&scoped=true&"
import script from "./claimReportApply.vue?vue&type=script&lang=js&"
export * from "./claimReportApply.vue?vue&type=script&lang=js&"
import style0 from "./claimReportApply.vue?vue&type=style&index=0&id=2ef4a4df&lang=scss&scoped=true&"
import style1 from "./claimReportApply.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef4a4df",
  null
  
)

export default component.exports